import Slider from 'react-slick';
import ProductCard from '../ProductCard';
import { forwardRef, useImperativeHandle, useRef } from 'react';

const ProductsSlider = forwardRef(
    ({ products, slidesToShow = 8, slideStep = 1, onPositionChange }, ref) => {
        const sliderRef = useRef(null);

        useImperativeHandle(ref, () => ({
            next: () => sliderRef.current?.slickNext(),
            prev: () => sliderRef.current?.slickPrev(),
            goTo: (index) => sliderRef.current?.slickGoTo(index),
        }));

        const handleAfterChange = (index) => {
            const isStart = index === 0;
            const isEnd = index + slidesToShow >= products?.length;
            onPositionChange?.(isStart, isEnd);
        };

        const settings = {
            infinite: false,
            speed: 500,
            slidesToShow,
            slidesToScroll: slideStep,
            arrows: false,
            dots: false,
            swipeToSlide: true,
            afterChange: handleAfterChange,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        dots: true,
                    },
                },
                {
                    breakpoint: 992,
                    settings: { slidesToShow: 4, slidesToScroll: 1 },
                },
                {
                    breakpoint: 768,
                    settings: { slidesToShow: 2, slidesToScroll: 1 },
                },
                {
                    breakpoint: 480,
                    settings: { slidesToShow: 2, slidesToScroll: 1 },
                },
            ],
        };

        return (
            <div className="products-slider w-full">
                <Slider ref={sliderRef} {...settings}>
                    {products.map((product) => (
                        <div key={product.netsuite_id} className="p-1">
                            <ProductCard product={product} />
                        </div>
                    ))}
                </Slider>
            </div>
        );
    }
);

export default ProductsSlider;
